<style>
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Data Anggota {{ details.kapa }}
      <CRow class="px-4 py-2 ml-auto">
        <div class="col-sm-6">
          <CButton class="btn btn-success" @click="myModal = true">
            Tambah
          </CButton>
        </div>
        <div class="col-sm-6">          
          <Button
            class="btn btn-md btn-dark text-white"
            @click="$router.go(-1)"
          >
            Kembali
          </Button>
        </div>
      </CRow>
    </CCardHeader>
    <!-- Tabs -->
  
    <!-- Data BPK -->
    <CCardBody>              
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              v-model.number="pageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."              
              v-model="search"
            />
          </div>
        </div>
      </CRow>            
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter :loading="loading">
            <template #no="{ index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2 font-weight-bold">
                {{item.no_anggota ? item.no_anggota : "-"}}
              </td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">
                {{item.nama_lengkap ? item.nama_lengkap : "-"}}
              </td>              
            </template>            
            <template #no_telephone="{item}">
              <td class="py-2">{{item.no_telephone ? item.no_telephone : "-"}}</td>
            </template>                       
            <template #updated_at="{item}">
              <td class="py-2">{{item.updated_at ? formatDate(item.updated_at, 'DD-MM-YYYY') : '-'}}</td>
            </template>                       
            <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">              
                <router-link :to="'/keanggotaan/data-anggota/data-diri/'+item.id_user">
                  <CButton color="warning" class="btn-sm text-white" square>
                    <font-awesome-icon icon="user" />
                  </CButton>
                </router-link>&nbsp;&nbsp;                
                <CButton color="danger" class="btn-sm text-white ml-2" square @click="deleteData(item)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Tambah Anggota"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">
            Tambah Anggota
          </h6>
        </template>
        <CForm>
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nama" class="font-weight-bold">Anggota</label>                    
                    <multiselect 
                      v-model="anggota" 
                      placeholder="Pilih Anggota" 
                      label="nama_lengkap" 
                      track-by="email" 
                      :options="anggotaNonKap" 
                      :multiple="true"                      
                    >                    
                      <template v-slot:noResult>
                        User tidak ditemukan
                      </template>
                    </multiselect>                                                      
                  </div>      
                </div>            
              </form>
            </div>
          </CRow>
        </CForm>        
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail User -->
      <!-- <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Kategori Anggota</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
              <p class="font-weight-bold">Email</p>
            </div>
            <div class="col-7">
              <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
              <p>: {{ formData.nama_kategori ? formData.nama_kategori : ' - ' }}</p>
              <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
              <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
              <p>: {{ formData.email ? formData.email : ' - ' }}</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal> -->
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import { DateUtils } from '@/mixins/DateUtils';
import { AlertUtils } from '@/mixins/AlertUtils';
import KapService from "@/services/keanggotaan/kap.service";
import AnggotaKapService from '@/services/keanggotaan/anggota-kap.service';

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    _style: "font-weight: bold !important",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: true,
    filter: false
  },
  {
    key: "no_telephone",
    label: "No. Telephone",
    sorter: true,
    filter: false
  }, 
  {
    key: "updated_at",
    label: "Tanggal Update",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "data-anggota-kap",

  mixins: [
    AlertUtils,
    DateUtils
  ],

  data() {
    return {
      search: "",
      pageSize: 10,
      items: [],
      anggotaKap: [],
      anggotaNonKap: [],
      indexed : "",            
      pagination: {
        totalPages: 0
      },

      loading: false,
      anggota: [],
    
      fields,
      currentPage: 0,
      details: {},

      status: false,
      myModal: false,
      modalDetail: false,      
    };
  },
  mounted() {    
    this.getAnggotaNonKap();
    this.getDetail(this.$route.params.id_kap);
    this.getData("0", this.pageSize, "default");
  },

  watch: {
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search);
    },
    search: function(val) {
      setTimeout(() => {
        this.getData("0", this.pageSize, this.search);
      }, 1000)
    }
  },
  
  methods: {
    changePageSize(e) {      
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search,);
    },    

    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    },            

    postData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      let vm = this;
      vm.loading = true;

      try {
        for (let i = 0; i < this.anggota.length; i++) {
          const element = this.anggota[i];
          const data = {
            id_user: element.id_user,
            id_kap: this.$route.params.id_kap
          };
          AnggotaKapService.postAnggotaKap(data)
            .then(response => {
              // comment console console.log(response)                            
              vm.getAnggotaNonKap();
              vm.getData(vm.currentPage - 1, vm.pageSize, vm.search);              
            })
            .catch(error => {              
              // comment console console.log(error)            
            })
        }              
        vm.anggota = [];
        vm.myModal = false;
        vm.loading = false;
        loader.hide();
        vm.alertSuccess();
      } catch (error) {
        this.getAnggotaNonKap();
        this.getData(this.currentPage - 1, this.pageSize, this.search);
        this.myModal = false;
        loader.hide();
        this.alertError(error.data.message)
      }
    },

    deleteData(item, index) {
      var vm = this;
      vm.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            AnggotaKapService.deleteAnggotaKap(item.id_anggota_kap)
              .then(response => {                
                vm.alertDeleteSuccess();
                this.getAnggotaNonKap();
                this.getData(this.currentPage - 1, this.pageSize, this.search);
              })
              .catch(error => {
                vm.alertErrorUser();
                // comment console console.log(error);
              });
          } else {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter) {          
      var vm = this;
      const idKap = this.$route.params.id_kap
      AnggotaKapService.getAnggotaKap(currentPage, pageSize, filter, idKap)
        .then((response) => {          
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber + 1;          
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getDetail(idkap) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      KapService.getDetailKap(idkap)
        .then(response => {
          this.details = response.data.data
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },

    getAnggotaNonKap() {
      AnggotaKapService.getDataAnggotaNonKap()
        .then(response => {
          // comment console console.log(response)
          this.anggotaNonKap = response.data.data
        })
        .catch(error => {
          // comment console console.log(error)
        })
    },        
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>